<template>
    <div class="box">
        <inner-table id="innerWorkResume" ref="workResumeList" :listviewurl="'rsgl.archiveWorkExperience.list'" :can-edit="canEdit" :can-delete="canEdit" :link-prop-name="''" />
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
        vo: {},
        canEdit: { type: Number, default: 1 }
    },
    data() {
        return {
            moduleInfo: {'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/xsgl/archiveWorkExperience/form.html', 'addNewUrl': 'xsgl/rsglArchiveWorkExperience/addNew', 'insertUrl': 'xsgl/rsglArchiveWorkExperience/insert', 'getByIdUrl': 'xsgl/rsglArchiveWorkExperience/getById', 'updateUrl': 'xsgl/rsglArchiveWorkExperience/update', 'delUrl': 'xsgl/rsglArchiveWorkExperience/delete', 'listDataUrl': 'xsgl/rsglArchiveWorkExperience/listdata', 'winWidth': 1000, 'winHeight': 600, 'moduleCode': 'archiveWorkExperience', 'openViewType': '0', 'listAdvSearchAllFields': 0, 'listAdvSearchExpandPanel': 0},
            formTitle: '工作经历'
        }
    },
    computed: {},
    watch: {},
    created: function() {
        let formurl = this.moduleInfo.formTemplate.split('url=')[1]
        formurl = formurl.replace(/\//g, '.')
        formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
        formurl += '?sysCode=' + (this.$route.meta.sysCode || '')
        this.$options.components['BusiForm'] = this.$loadComponent(formurl)
    },
    mounted: function() {
    },
    methods: {
        addObject() {
            this.$bus.emit('openBusiform', this.moduleInfo, null, 1)
        },
        // 内嵌子表-子表单提交前回调
        onInnerBasicFormBeforeSubmit($scope, vo, defer) {
            //vo.archivesId = vo.userId
            defer.resolve(true)
        }
    }
}
</script>

<style scoped>
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
   border:1px solid #dee2e6;
}
</style>

